/* eslint-disable quote-props */
import { styled } from "@mui/material/styles";

export const GridAutoColumns = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateRows: "repeat(auto-fill, minmax(100px, 1fr))", // Reduced min height to 100px
  gap: "1rem",
}));

export const GridAutoColumn120 = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(120px, 1fr))",
  gap: ".5rem",
}));

export const AutoComplete = styled("div")(({ theme }) => ({
  position: "relative",
  zIndex: 99,
}));

export const Listbox = styled("ul")(({ theme }) => ({
  width: "100%",
  margin: 0,
  padding: 0,
  zIndex: 1,
  // position: "absolute",
  listStyle: "none",
  backgroundColor: theme.palette.background.paper,
  overflow: "auto",
  maxHeight: 200,
  fontSize: "13px",
  border: `1px solid ${theme.palette.taupe.light}`,
  top: "64px",
  borderRadius: "8px",
  "& li": {
    padding: "10px",
    borderBottom: `1px solid ${theme.palette.sand.main}`,
  },
  "& li:hover": {
    backgroundColor: theme.palette.primary.light,
    cursor: "pointer",
  },
}));

export const Card = styled("div")(({ theme }) => ({
  padding: "16px",
  border: "1px solid #DAD7D6",
  borderRadius: theme.shape.borderRadius,
  marginBottom: "1rem",
}));


export const ButtonList = styled("div")(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  background: "rgb(255 255 255 / 97%);",
  fontFamily: "atlas-grotesk-regular",
  fontStyle: "normal",
  fontWeight: "400",
  fontSize: "14px",
  letterSpacing: "-0.02em",
  textAlign: "center",
  margin: ".65rem 0",
  padding: ".85rem",
  transition: "all .3s",
  ":hover": {
    cursor: "pointer",
  },
}));

export const LinkExtern = styled("a")(({ theme }) => ({
  fontWeight: "bold",
  textDecoration: "underline",
  lineHeight: "20px",
}));

export const ListItem = styled("li")(({ theme }) => ({
  color: "#000000",
  opacity: "1",
}));
